// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: 'https://localhost:7172' | (string & {});
};

export type AddFolderPermissionsEwsCommand = {
    graphFolderId: string | null;
    exchangeFolderId?: string | null;
    changePermissionsInput: ChangePermissionsInput;
    applyRecursive?: boolean;
};

export type AddFolderPermissionsEwsResult = {
    message: string | null;
};

export type ApplyPermissionsAllEwsCommand = {
    graphFolderId: string | null;
    exchangeFolderId?: string | null;
};

export type ApplyPermissionsAllEwsResult = {
    message: string | null;
};

export type ApplyPermissionsSelectedEwsCommand = {
    graphFolderId: string | null;
    exchangeFolderId?: string | null;
    targetGraphFolderIds: Array<string> | null;
};

export type ApplyPermissionsSelectedEwsResult = {
    message: string | null;
};

export type ChangePermissionsInput = {
    userMailCollection?: Array<string> | null;
    permissionLevel?: FolderPermissionLevel;
    readItems?: FolderPermissionReadAccess;
    deleteItems?: PermissionScope;
    editItems?: PermissionScope;
    canCreateItems?: boolean;
    canCreateSubfolders?: boolean;
    isFolderContact?: boolean;
    isFolderOwner?: boolean;
    isFolderVisible?: boolean;
};

export type ErrorResponse500 = {
    traceId: string | null;
    timestamp?: string;
    statusCode?: number;
    message: string | null;
};

export enum FolderPermissionLevel {
    NONE = 'None',
    OWNER = 'Owner',
    PUBLISHING_EDITOR = 'PublishingEditor',
    EDITOR = 'Editor',
    PUBLISHING_AUTHOR = 'PublishingAuthor',
    AUTHOR = 'Author',
    NONEDITING_AUTHOR = 'NoneditingAuthor',
    REVIEWER = 'Reviewer',
    CONTRIBUTOR = 'Contributor',
    FREE_BUSY_TIME_ONLY = 'FreeBusyTimeOnly',
    FREE_BUSY_TIME_AND_SUBJECT_AND_LOCATION = 'FreeBusyTimeAndSubjectAndLocation',
    CUSTOM = 'Custom'
}

export enum FolderPermissionReadAccess {
    NONE = 'None',
    TIME_ONLY = 'TimeOnly',
    TIME_AND_SUBJECT_AND_LOCATION = 'TimeAndSubjectAndLocation',
    FULL_DETAILS = 'FullDetails'
}

export type GetFolderPermissionsEwsPermissionInfo = {
    user?: string | null;
    email?: string | null;
    canCreateItems?: boolean;
    canCreateSubFolders?: boolean;
    isFolderOwner?: boolean;
    isFolderVisible?: boolean;
    isFolderContact?: boolean;
    permissionLevel?: FolderPermissionLevel;
    readItems?: FolderPermissionReadAccess;
    deleteItems?: PermissionScope;
    editItems?: PermissionScope;
};

export type GetFolderPermissionsEwsResult = {
    permissions?: Array<GetFolderPermissionsEwsPermissionInfo> | null;
};

export type GetFoldersMsGraphResult = {
    graphFolderId?: string | null;
    exchangeFolderId?: string | null;
    folderName?: string | null;
    hasChildFolders?: boolean | null;
};

export type GetUsersMsGraphResult = {
    mail?: string | null;
    displayName?: string | null;
};

export enum PermissionScope {
    NONE = 'None',
    OWNED = 'Owned',
    ALL = 'All'
}

export type RemoveFolderPermissionsEwsCommand = {
    graphFolderId: string | null;
    exchangeFolderId?: string | null;
    targetUserEmail: string | null;
    applyRecursive?: boolean;
};

export type RemoveFolderPermissionsEwsResult = {
    message: string | null;
};

export type SmartLicense = {
    client?: string | null;
    domains?: Array<string> | null;
    subscriptionType?: SubscriptionType;
    expiry?: string | null;
    productGuid?: string;
    settingsJson?: string | null;
};

export enum SubscriptionType {
    DEMO = 'Demo',
    PRO_USER = 'ProUser',
    FLAT_RATE = 'FlatRate',
    WAITING = 'Waiting'
}

export type UpdateFolderPermissionsEwsCommand = {
    graphFolderId: string | null;
    exchangeFolderId?: string | null;
    changePermissionsInput: ChangePermissionsInput;
    applyRecursive?: boolean;
};

export type UpdateFolderPermissionsEwsResult = {
    message: string | null;
};

export type GetApiGraphFoldersData = {
    body?: never;
    path?: never;
    query?: {
        ParentGraphFolderId?: string;
    };
    url: '/api/Graph/folders';
};

export type GetApiGraphFoldersErrors = {
    /**
     * Internal Server Error
     */
    500: ErrorResponse500;
};

export type GetApiGraphFoldersError = GetApiGraphFoldersErrors[keyof GetApiGraphFoldersErrors];

export type GetApiGraphFoldersResponses = {
    /**
     * OK
     */
    200: Array<GetFoldersMsGraphResult>;
};

export type GetApiGraphFoldersResponse = GetApiGraphFoldersResponses[keyof GetApiGraphFoldersResponses];

export type GetApiGraphUsersData = {
    body?: never;
    path?: never;
    query?: {
        SearchString?: string;
    };
    url: '/api/Graph/users';
};

export type GetApiGraphUsersErrors = {
    /**
     * Internal Server Error
     */
    500: ErrorResponse500;
};

export type GetApiGraphUsersError = GetApiGraphUsersErrors[keyof GetApiGraphUsersErrors];

export type GetApiGraphUsersResponses = {
    /**
     * OK
     */
    200: Array<GetUsersMsGraphResult>;
};

export type GetApiGraphUsersResponse = GetApiGraphUsersResponses[keyof GetApiGraphUsersResponses];

export type GetApiLicenseCheckData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/License/check';
};

export type GetApiLicenseCheckErrors = {
    /**
     * Internal Server Error
     */
    500: ErrorResponse500;
};

export type GetApiLicenseCheckError = GetApiLicenseCheckErrors[keyof GetApiLicenseCheckErrors];

export type GetApiLicenseCheckResponses = {
    /**
     * OK
     */
    200: boolean;
};

export type GetApiLicenseCheckResponse = GetApiLicenseCheckResponses[keyof GetApiLicenseCheckResponses];

export type GetApiLicenseCurrentData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/License/current';
};

export type GetApiLicenseCurrentErrors = {
    /**
     * Internal Server Error
     */
    500: ErrorResponse500;
};

export type GetApiLicenseCurrentError = GetApiLicenseCurrentErrors[keyof GetApiLicenseCurrentErrors];

export type GetApiLicenseCurrentResponses = {
    /**
     * OK
     */
    200: SmartLicense;
};

export type GetApiLicenseCurrentResponse = GetApiLicenseCurrentResponses[keyof GetApiLicenseCurrentResponses];

export type GetApiLicenseVersionData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/License/version';
};

export type GetApiLicenseVersionErrors = {
    /**
     * Internal Server Error
     */
    500: ErrorResponse500;
};

export type GetApiLicenseVersionError = GetApiLicenseVersionErrors[keyof GetApiLicenseVersionErrors];

export type GetApiLicenseVersionResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetApiLicenseVersionResponse = GetApiLicenseVersionResponses[keyof GetApiLicenseVersionResponses];

export type GetApiPermissionsByGraphFolderIdData = {
    body?: never;
    path: {
        graphFolderId: string;
    };
    query?: {
        exchangeFolderId?: string;
    };
    url: '/api/Permissions/{graphFolderId}';
};

export type GetApiPermissionsByGraphFolderIdErrors = {
    /**
     * Internal Server Error
     */
    500: ErrorResponse500;
};

export type GetApiPermissionsByGraphFolderIdError = GetApiPermissionsByGraphFolderIdErrors[keyof GetApiPermissionsByGraphFolderIdErrors];

export type GetApiPermissionsByGraphFolderIdResponses = {
    /**
     * OK
     */
    200: GetFolderPermissionsEwsResult;
};

export type GetApiPermissionsByGraphFolderIdResponse = GetApiPermissionsByGraphFolderIdResponses[keyof GetApiPermissionsByGraphFolderIdResponses];

export type PostApiPermissionsApplyAllData = {
    body?: ApplyPermissionsAllEwsCommand;
    path?: never;
    query?: never;
    url: '/api/Permissions/apply-all';
};

export type PostApiPermissionsApplyAllErrors = {
    /**
     * Internal Server Error
     */
    500: ErrorResponse500;
};

export type PostApiPermissionsApplyAllError = PostApiPermissionsApplyAllErrors[keyof PostApiPermissionsApplyAllErrors];

export type PostApiPermissionsApplyAllResponses = {
    /**
     * Created
     */
    201: ApplyPermissionsAllEwsResult;
};

export type PostApiPermissionsApplyAllResponse = PostApiPermissionsApplyAllResponses[keyof PostApiPermissionsApplyAllResponses];

export type PostApiPermissionsApplySelectedData = {
    body?: ApplyPermissionsSelectedEwsCommand;
    path?: never;
    query?: never;
    url: '/api/Permissions/apply-selected';
};

export type PostApiPermissionsApplySelectedErrors = {
    /**
     * Internal Server Error
     */
    500: ErrorResponse500;
};

export type PostApiPermissionsApplySelectedError = PostApiPermissionsApplySelectedErrors[keyof PostApiPermissionsApplySelectedErrors];

export type PostApiPermissionsApplySelectedResponses = {
    /**
     * Created
     */
    201: ApplyPermissionsSelectedEwsResult;
};

export type PostApiPermissionsApplySelectedResponse = PostApiPermissionsApplySelectedResponses[keyof PostApiPermissionsApplySelectedResponses];

export type PostApiPermissionsByGraphFolderIdAddData = {
    body?: AddFolderPermissionsEwsCommand;
    path: {
        graphFolderId: string;
    };
    query?: never;
    url: '/api/Permissions/{graphFolderId}/add';
};

export type PostApiPermissionsByGraphFolderIdAddErrors = {
    /**
     * Internal Server Error
     */
    500: ErrorResponse500;
};

export type PostApiPermissionsByGraphFolderIdAddError = PostApiPermissionsByGraphFolderIdAddErrors[keyof PostApiPermissionsByGraphFolderIdAddErrors];

export type PostApiPermissionsByGraphFolderIdAddResponses = {
    /**
     * Created
     */
    201: AddFolderPermissionsEwsResult;
};

export type PostApiPermissionsByGraphFolderIdAddResponse = PostApiPermissionsByGraphFolderIdAddResponses[keyof PostApiPermissionsByGraphFolderIdAddResponses];

export type DeleteApiPermissionsByGraphFolderIdRemoveData = {
    body?: RemoveFolderPermissionsEwsCommand;
    path: {
        graphFolderId: string;
    };
    query?: never;
    url: '/api/Permissions/{graphFolderId}/remove';
};

export type DeleteApiPermissionsByGraphFolderIdRemoveErrors = {
    /**
     * Internal Server Error
     */
    500: ErrorResponse500;
};

export type DeleteApiPermissionsByGraphFolderIdRemoveError = DeleteApiPermissionsByGraphFolderIdRemoveErrors[keyof DeleteApiPermissionsByGraphFolderIdRemoveErrors];

export type DeleteApiPermissionsByGraphFolderIdRemoveResponses = {
    /**
     * OK
     */
    200: RemoveFolderPermissionsEwsResult;
};

export type DeleteApiPermissionsByGraphFolderIdRemoveResponse = DeleteApiPermissionsByGraphFolderIdRemoveResponses[keyof DeleteApiPermissionsByGraphFolderIdRemoveResponses];

export type PutApiPermissionsByGraphFolderIdUpdateData = {
    body?: UpdateFolderPermissionsEwsCommand;
    path: {
        graphFolderId: string;
    };
    query?: never;
    url: '/api/Permissions/{graphFolderId}/update';
};

export type PutApiPermissionsByGraphFolderIdUpdateErrors = {
    /**
     * Internal Server Error
     */
    500: ErrorResponse500;
};

export type PutApiPermissionsByGraphFolderIdUpdateError = PutApiPermissionsByGraphFolderIdUpdateErrors[keyof PutApiPermissionsByGraphFolderIdUpdateErrors];

export type PutApiPermissionsByGraphFolderIdUpdateResponses = {
    /**
     * Created
     */
    201: UpdateFolderPermissionsEwsResult;
};

export type PutApiPermissionsByGraphFolderIdUpdateResponse = PutApiPermissionsByGraphFolderIdUpdateResponses[keyof PutApiPermissionsByGraphFolderIdUpdateResponses];
